import React, { Component } from 'react';
import axios from 'axios'
import * as moment from 'moment';
import { serverIp,  } from '../../../../config/constants.js'
import { Button, Icon } from 'semantic-ui-react'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'


class ConfirmOrderReminder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: ''
        }
    }

    componentDidMount() {
        console.log("++++++++++:sendConfirmationReminder");
        console.log("this.props.order.key:" + this.props.order.key);
    }

    sendUpdateToApi = (sentType) => {

        axios.post(serverIp + 'sms/sendConfirmationReminder', {
            apiKey: 'asdfasdf@da7',
            fbOrderKey: this.props.mainOrder.key,
        })
            .then((response) => {
                console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
            });

        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');

        let orderUpdates = {
            confirmationReminderSent: true,
            confirmationReminderSentBy: this.props.user.email,
            lastUpdate: now,
            status: 'lost'
        }

        //upATE MAIN ORDER
        FbUtils.updateOrder(this.props.mainOrder.key, orderUpdates);
    }

    render() {

        const sendReminderButton = this.props.order.depositReminderSent
            ? <h3><Icon loading name='asterisk' /> CONFRIM SENT </h3>
            : <Button type='Button' onClick={this.sendUpdateToApi} type='button' color='purple' fluid size='large'>SEND CONFIRM REMINDER</Button>

        return (
            <div>
                {sendReminderButton}
            </div>
        )
    }
}

export default ConfirmOrderReminder;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ConfirmOrderReminder/ConfirmOrderReminder.js